import { z } from 'zod';
import { BaseIntegratorDTOSchema, BaseAuthUserDTOSchema } from "./auth.dto.js";
// Schema for create integrator input
export const CreateIntegratorInputDTOSchema = BaseIntegratorDTOSchema.pick({
    email: true,
    name: true,
}).extend({
    password: z.string().min(8),
    companyId: BaseIntegratorDTOSchema.shape.defaultCompanyId.unwrap().optional(),
    createdBy: BaseAuthUserDTOSchema.shape.id,
});
// Schema for create integrator output
export const CreateIntegratorOutputDTOSchema = BaseIntegratorDTOSchema.pick({
    id: true,
    email: true,
    name: true,
}).extend({
    companyId: BaseIntegratorDTOSchema.shape.defaultCompanyId,
    apiKey: z.string().nullable(),
    message: z.string(),
});
// Request and response schemas for API layer
export const CreateIntegratorRequestDTOSchema = z.object({
    body: CreateIntegratorInputDTOSchema.omit({ createdBy: true }),
});
//# sourceMappingURL=create-integrator.dto.js.map